/**
 * Create store system routing-policy
 *
 * @since 2018-06-25
 * @author jongsung.Lee(devp010)
 */

import {SystemApiPrefix as smApiPrefix} from 'utils'

export const plugins = [Plugin]

export const state = () => ({
  // axios api's urls
  apiUrlPath: {
    // policy entry interface
    staticRouteCandidates: `${smApiPrefix}/static-routings/interface-candidates`,
    // policy routing
    routingMarkers: `${smApiPrefix}/routing-markers`,
    policyTables: `${smApiPrefix}/policy-tables`,
    policyTableEntries: `${smApiPrefix}/policy-tables/{id}/entries`,
    routingPolicies: `${smApiPrefix}/routing-policies`
  },
  // copyData of editing.
  selectedItem: {},
  routingMarker: {
    id: 0,
    name: '',
    desc: ''
  },
  routingMarkerList: [],
  policyTable: {
    id: 0,
    name: ''
  },
  policyTableList: [],
  policyTableEntry: {
    entry_id: 0,
    tblId: 0,
    type: 0,
    multipath: 0,
    dest_addr: '',
    dest_mask: 0,
    metric: 0,
    gw: []
  },
  policyTableEntryList: [],
  staticRoutingGw: {
    id: 0,
    addr: '', //      게이트웨이 주소
    ifc_id: '', //     게이트웨이 인터페이스 ID
    ifc_name: '', //  게이트웨이 인터페이스 이름
    weight: 1 //      가중치
  },
  gatewayCandidates: [],
  routingPolicy: {
    id: 0,
    priority: 101,
    srcIpType: 0,
    src_addr: null,
    src_mask: 0,
    destIpType: 0,
    dest_addr: '',
    dest_mask: 0,
    marker_id: 0,
    marker_name: '',
    table_id: 0,
    table_name: ''
  },
  routingPolicyList: [],
  // select-box data
  markerSelectList: [],
  policyTblSelectList: []
})

export const mutations = {
  resetSelectedItem (state) {
    state.selectedItem = {}
  },
  setSelectedItem (state, item) {
    state.selectedItem = item
  },
  // policy marker
  resetRoutingMakerList (state) {
    state.routingMarkerList = []
    state.markerSelectList = []
  },
  setRoutingMakerList (state, data) {
    if (data !== undefined) {
      state.routingMarkerList = data
    }
  },
  setMarkerSelectList (state) {
    const mSelectList = _.cloneDeep(state.routingMarkerList)
    state.markerSelectList = []
    for (const d of mSelectList) {
      state.markerSelectList.push(
        {
          label: d.name,
          value: d.id
        }
      )
    }
  },
  clearMarkerDialog (state) {
    state.routingMarker.id = 0
    state.routingMarker.name = ''
    state.routingMarker.desc = ''
  },
  setMarkerDialog (state, item) {
    if (item !== undefined) {
      state.routingMarker.id = item.id
      state.routingMarker.name = item.name
      state.routingMarker.desc = item.desc
    }
  },
  // policy table
  resetPolicyTableList (state) {
    state.policyTableList = []
    state.policyTblSelectList = []
  },
  setPolicyTableList (state, data) {
    if (data !== undefined) {
      state.policyTableList = data
    }
  },
  setPolicyTblSelectList (state) {
    const pSelectList = _.cloneDeep(state.policyTableList)
    state.policyTblSelectList = []
    for (const d of pSelectList) {
      state.policyTblSelectList.push(
        {
          label: d.name,
          value: d.id
        }
      )
    }
  },
  clearPolicyTableDialog (state) {
    state.selectedItem = null
    state.policyTable.id = 0
    state.policyTable.name = ''
  },
  setPolicyTableDialog (state, item) {
    if (item !== undefined) {
      state.selectedItem = item
      state.policyTable.id = item.id
      state.policyTable.name = item.name
    }
  },
  // policy tableEntry
  resetPolicyTableEntryList (state) {
    state.policyTableEntryList = []
  },
  setPolicyTableEntryList (state, data) {
    if (data !== undefined) {
      state.policyTableEntryList = data
    }
  },
  clearPolicyTableEntryDialog (state) {
    state.selectedItem = null
    state.policyTableEntry.entry_id = 0
    state.policyTableEntry.tblId = 0
    state.policyTableEntry.type = 0
    state.policyTableEntry.multipath = 0
    state.policyTableEntry.dest_addr = null
    state.policyTableEntry.dest_mask = 0
    state.policyTableEntry.metric = 0
    state.policyTableEntry.gw = []
  },
  setPolicyTableEntryDialog (state, item) {
    if (item !== undefined) {
      state.selectedItem = item
      state.policyTableEntry.entry_id = item.entry_id
      state.policyTableEntry.tblId = item.tblId
      state.policyTableEntry.type = item.type
      state.policyTableEntry.multipath = item.multipath
      state.policyTableEntry.dest_addr = (item.dest_addr === '') ? null : item.dest_addr
      state.policyTableEntry.dest_mask = item.dest_mask
      state.policyTableEntry.metric = item.metric
      state.policyTableEntry.gw = item.gw
    }
  },
  clearStaticRoutingGwDialog (state) {
    state.staticRoutingGw.id = 0
    state.staticRoutingGw.addr = null
    state.staticRoutingGw.ifc_id = ''
    state.staticRoutingGw.ifc_name = ''
    state.staticRoutingGw.weight = 1
  },
  setStaticRoutingGwDialog (state, item) {
    if (item !== undefined) {
      state.staticRoutingGw.id = item.id
      state.staticRoutingGw.addr = item.addr
      state.staticRoutingGw.ifc_id = item.ifc_id
      state.staticRoutingGw.ifc_name = item.ifc_name
      state.staticRoutingGw.weight = item.weight
    }
  },
  // set candidates
  setPolicyRouteCandidates (state, items) {
    state.gatewayCandidates = []
    if (items !== undefined && items.length > 0) {
      for (const candi of items) {
        state.gatewayCandidates.push({
          label: candi.name,
          value: candi.id
        })
      }
    }
  },
  // RoutingPolicy table
  resetRoutingPolicyList (state) {
    state.routingPolicyList = []
  },
  setRoutingPolicyList (state, data) {
    if (data !== undefined && data.length > 0) {
      state.routingPolicyList = data
    }
  },
  clearRoutingPolicyDialog (state) {
    state.selectedItem = null
    state.routingPolicy.id = 0
    state.routingPolicy.priority = 101
    state.routingPolicy.src_addr = null
    state.routingPolicy.src_mask = 0
    state.routingPolicy.dest_addr = null
    state.routingPolicy.dest_mask = 0
    state.routingPolicy.marker_id = 0
    state.routingPolicy.marker_name = ''
    state.routingPolicy.table_id = 0
    state.routingPolicy.table_name = ''
  },
  setRoutingPolicyDialog (state, item) {
    if (item !== undefined) {
      state.selectedItem = item
      state.routingPolicy.id = item.id
      state.routingPolicy.priority = item.priority
      if (item.src_addr !== undefined && (item.src_addr === '0.0.0.0' && item.src_mask === 0)) {
        state.routingPolicy.srcIpType = 0
        state.routingPolicy.src_addr = null
        state.routingPolicy.src_mask = 0
      } else {
        state.routingPolicy.srcIpType = 1
        state.routingPolicy.src_addr = item.src_addr
        state.routingPolicy.src_mask = item.src_mask
      }
      if (item.dest_addr !== undefined && (item.dest_addr === '0.0.0.0' && item.dest_mask === 0)) {
        state.routingPolicy.destIpType = 0
        state.routingPolicy.dest_addr = null
        state.routingPolicy.dest_mask = 0
      } else {
        state.routingPolicy.destIpType = 1
        state.routingPolicy.dest_addr = item.dest_addr
        state.routingPolicy.dest_mask = item.dest_mask
      }
      state.routingPolicy.marker_id = item.marker_id
      state.routingPolicy.marker_name = item.marker_name
      state.routingPolicy.table_id = item.table_id
      state.routingPolicy.table_name = item.table_name
    }
  },
  // policy marker
  addRoutingMarkerList (state, item) {
    if (item !== undefined) {
      state.routingMarkerList.push(item)
    }
  },
  delRoutingMarkerList (state, itemIndexList) {
    if (itemIndexList !== null && itemIndexList !== undefined) {
      itemIndexList = _.orderBy(itemIndexList, ['itemIndex'], ['desc'])
      for (const item of itemIndexList) {
        state.routingMarkerList.splice(item.itemIndex, 1)
      }
    }
  },
  // policy table
  addPolicyTableList (state, item) {
    if (item !== undefined) {
      state.policyTableList.push(item)
      // add selectList
      state.policyTblSelectList.push(
        {
          label: item.name,
          value: item.id
        }
      )
    }
  },
  editPolicyTableList (state, item) {
    const findRslt = _.find(state.policyTableList, {id: item.id})
    if (findRslt !== undefined && findRslt.itemIndex !== undefined) {
      state.policyTableList.splice(_.findIndex(state.policyTableList, state.selectedItem), 1, item)
    }
  },
  delPolicyTableList (state, itemIndexList) {
    if (itemIndexList !== null && itemIndexList !== undefined) {
      itemIndexList = _.orderBy(itemIndexList, ['itemIndex'], ['desc'])
      for (const item of itemIndexList) {
        state.policyTableList.splice(item.itemIndex, 1)
      }
    }
  },
  // policy tableEntry
  addPolicyTableEntryList (state, item) {
    if (item !== undefined) {
      state.policyTableEntryList.push(item)
    }
  },
  editPolicyTableEntryList (state, item) {
    const findRslt = _.find(state.policyTableEntryList, {entry_id: item.entry_id})
    if (findRslt !== undefined && findRslt.itemIndex !== undefined) {
      state.policyTableEntryList.splice(_.findIndex(state.policyTableEntryList, state.selectedItem), 1, item)
    }
  },
  delPolicyTableEntryList (state, itemIndexList) {
    if (itemIndexList !== null && itemIndexList !== undefined) {
      itemIndexList = _.orderBy(itemIndexList, ['itemIndex'], ['desc'])
      for (const item of itemIndexList) {
        state.policyTableEntryList.splice(item.itemIndex, 1)
      }
    }
  },
  // add, edit, delete policyTableEntry gateway
  addPolicyRoutingGw (state, item) {
    state.policyTableEntry.gw.push(item)
  },
  editPolicyRoutingGw (state, item) {
    const findRslt = _.find(state.staticRouting.gw, {id: item.id})
    if (findRslt !== undefined && findRslt.itemIndex !== undefined) {
      state.policyTableEntry.gw.splice(_.findIndex(state.staticRouting.gw, state.selectedItem), 1, item)
    }
  },
  delPolicyRoutingGw (state, itemIndexList) {
    if (itemIndexList !== null && itemIndexList !== undefined) {
      itemIndexList = _.orderBy(itemIndexList, ['itemIndex'], ['desc'])
      for (const item of itemIndexList) {
        state.policyTableEntry.gw.splice(item.itemIndex, 1)
      }
    }
  },
  // RoutingPolicy table
  addRoutingPolicyList (state, item) {
    if (item !== undefined) {
      state.routingPolicyList.push(item)
    }
  },
  editRoutingPolicyList (state, item) {
    const findRslt = _.find(state.routingPolicyList, {id: item.id})
    if (findRslt !== undefined && findRslt.itemIndex !== undefined) {
      state.routingPolicyList.splice(_.findIndex(state.routingPolicyList, state.selectedItem), 1, item)
    }
  },
  delRoutingPolicyList (state, itemIndexList) {
    if (itemIndexList !== null && itemIndexList !== undefined) {
      itemIndexList = _.orderBy(itemIndexList, ['itemIndex'], ['desc'])
      for (const item of itemIndexList) {
        state.routingPolicyList.splice(item.itemIndex, 1)
      }
    }
  }
}

export const actions = {
  // >>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>> routing maker
  async getRoutingMarkerList ({commit, state}, loadingOpt) {
    commit('resetRoutingMakerList')
    const {code, result} = await this.$axios.$get(state.apiUrlPath['routingMarkers'], loadingOpt)
    if (code !== undefined && (code).toLowerCase() === 'ok') {
      // commit for staticRouting
      commit('setRoutingMakerList', result)
      // set select-box by marker
      commit('setMarkerSelectList')
      return true
    } else {
      return false
    }
  },
  async addRoutingMarkerList ({commit, state}) {
    const addParam = {
      name: state.routingMarker.name,
      desc: state.routingMarker.desc
    }
    const {code, result} = await this.$axios.$post(state.apiUrlPath['routingMarkers'], addParam)
    if (code !== undefined && (code).toLowerCase() === 'ok') {
      commit('addRoutingMarkerList', result)
      // set select-box by marker
      commit('setMarkerSelectList')
      return true
    } else {
      return false
    }
  },
  async delRoutingMarkerList ({commit, state}, param) {
    // apply partialError.
    const res = {code: 'nok'}
    // multi delete
    const delParam = {items: []}
    for (const idx of param.idList) {
      delParam.items.push({id: idx.id, pokName: idx.pokName})
    }
    let rslt
    if (param.idList !== undefined && param.idList.length === 1) {
      // single
      rslt = await this.$axios.$delete(`${state.apiUrlPath['routingMarkers']}/${param.idList[0].id}`)
    } else {
      // multi
      rslt = await this.$axios.$delete(state.apiUrlPath['routingMarkers'], {data: delParam})
    }
    if (rslt.code !== undefined && (rslt.code).toLowerCase() === 'ok') {
      commit('delRoutingMarkerList', param.itemIndexList)
      // set select-box by marker
      commit('setMarkerSelectList')
      res.code = 'ok'
      return res
    } else {
      res.code = rslt.code
      res.errors = rslt.result.errors
      return res
    }
  },
  // <<<<<<<<<<<<<<<<<<<<<<<<<<<<<<<<<<<<<<<<<<<< routing maker
  // >>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>> policy table
  async getPolicyTableList ({commit, state}, loadingOpt) {
    commit('resetPolicyTableList')
    const {code, result} = await this.$axios.$get(state.apiUrlPath['policyTables'], loadingOpt)
    if (code !== undefined && (code).toLowerCase() === 'ok') {
      // commit for staticRouting
      commit('setPolicyTableList', result)
      // set select-box by policyTable
      commit('setPolicyTblSelectList')
      return true
    } else {
      return false
    }
  },
  async addPolicyTableList ({commit, state}) {
    const addParam = {
      name: state.policyTable.name
    }
    const {code, result} = await this.$axios.$post(state.apiUrlPath['policyTables'], addParam)
    if (code !== undefined && (code).toLowerCase() === 'ok') {
      commit('addPolicyTableList', result)
      commit('setPolicyTblSelectList')
      return true
    } else {
      return false
    }
  },
  async editPolicyTableList ({commit, state}) {
    const putParam = {
      name: state.policyTable.name
    }
    const url = `${state.apiUrlPath['policyTables']}/${state.policyTable.id}`
    const {code, result} = await this.$axios.$put(url, putParam)
    if (code !== undefined && (code).toLowerCase() === 'ok') {
      commit('editPolicyTableList', result)
      commit('setPolicyTblSelectList')
      return true
    } else {
      return false
    }
  },
  async delPolicyTableList ({commit, state}, param) {
    // apply partialError.
    const res = {code: 'nok'}
    // multi delete
    const delParam = {items: []}
    for (const idx of param.idList) {
      delParam.items.push({id: idx.id, pokName: idx.pokName})
    }
    let rslt
    const apiUrl = state.apiUrlPath['policyTables']
    if (param.idList !== undefined && param.idList.length === 1) {
      // single
      rslt = await this.$axios.$delete(`${apiUrl}/${param.idList[0].id}`)
    } else {
      // multi
      rslt = await this.$axios.$delete(apiUrl, {data: delParam})
    }
    if (rslt.code !== undefined && (rslt.code).toLowerCase() === 'ok') {
      commit('delPolicyTableList', param.itemIndexList)
      commit('setPolicyTblSelectList')
      res.code = 'ok'
      return res
    } else {
      res.code = rslt.code
      res.errors = rslt.result.errors
      return res
    }
  },
  // <<<<<<<<<<<<<<<<<<<<<<<<<<<<<<<<<<<<<<<<<<<< policy table
  // >>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>> policy tableEntry
  async getPolicyTableEntryList ({commit, state}, tblId) {
    const apiUrl = state.apiUrlPath['policyTableEntries'].replace('{id}', tblId)
    const {code, result} = await this.$axios.$get(apiUrl)
    if (code !== undefined && (code).toLowerCase() === 'ok') {
      // commit for staticRouting
      commit('setPolicyTableEntryList', result)
      return true
    } else {
      return false
    }
  },
  async getPolicyRoutingCandidate ({commit, state}) {
    // code, result const
    let {code, result} = await this.$axios.$get(state.apiUrlPath['staticRouteCandidates'])
    if (code !== undefined && (code).toLowerCase() === 'ok') {
      commit('setPolicyRouteCandidates', result)
      return true
    } else {
      return false
    }
  },
  addPolicyRoutingGw ({commit, state}, multiPath) {
    const addItem = _.cloneDeep(state.staticRoutingGw)
    addItem.id = _.random(10, 1000)
    if (multiPath === 0) {
      addItem.weight = 1
    }
    commit('addPolicyRoutingGw', addItem)
    return true
  },
  editPolicyRoutingGw ({commit, state}, multiPath) {
    const editItem = _.cloneDeep(state.staticRoutingGw)
    if (multiPath === 0) {
      editItem.weight = 1
    }
    commit('editPolicyRoutingGw', editItem)
    return true
  },
  delPolicyRoutingGw ({commit, state}, param) {
    commit('delPolicyRoutingGw', param.itemIndexList)
    return true
  },
  async addPolicyTableEntryList ({commit, state}, param) {
    const addParam = {
      type: state.policyTableEntry.type,
      multipath: state.policyTableEntry.multipath,
      dest_addr: state.policyTableEntry.dest_addr,
      dest_mask: Number(state.policyTableEntry.dest_mask),
      metric: state.policyTableEntry.metric,
      gw: state.policyTableEntry.gw
    }
    const apiUrl = state.apiUrlPath['policyTableEntries'].replace('{id}', param.tbl_id)
    const {code, result} = await this.$axios.$post(apiUrl, addParam)
    if (code !== undefined && (code).toLowerCase() === 'ok') {
      commit('addPolicyTableEntryList', result)
      return true
    } else {
      return false
    }
  },
  async editPolicyTableEntryList ({commit, state}, param) {
    const putParam = {
      entry_id: state.policyTableEntry.entry_id,
      type: state.policyTableEntry.type,
      multipath: state.policyTableEntry.multipath,
      dest_addr: state.policyTableEntry.dest_addr,
      dest_mask: Number(state.policyTableEntry.dest_mask),
      metric: state.policyTableEntry.metric,
      gw: state.policyTableEntry.gw
    }
    // real code
    const apiUrl = state.apiUrlPath['policyTableEntries'].replace('{id}', param.tbl_id)
    const {code, result} = await this.$axios.$put(`${apiUrl}/${putParam.entry_id}`, putParam)
    if (code !== undefined && (code).toLowerCase() === 'ok') {
      commit('editPolicyTableEntryList', result)
      return true
    } else {
      return false
    }
  },
  async delPolicyTableEntryList ({commit, state}, param) {
    // apply partialError.
    const res = {code: 'nok'}
    // multi delete
    const delParam = {items: []}
    for (const idx of param.idList) {
      delParam.items.push({entry_id: idx.entry_id, pokName: idx.pokName})
    }
    const apiUrl = state.apiUrlPath['policyTableEntries'].replace('{id}', param.policyTableId)
    let rslt
    if (param.idList !== undefined && param.idList.length === 1) {
      // single
      rslt = await this.$axios.$delete(`${apiUrl}/${param.idList[0].entry_id}`)
    } else {
      // multi
      rslt = await this.$axios.$delete(apiUrl, {data: delParam})
    }
    if (rslt.code !== undefined && (rslt.code).toLowerCase() === 'ok') {
      commit('delPolicyTableEntryList', param.itemIndexList)
      res.code = 'ok'
      return res
    } else {
      res.code = rslt.code
      res.errors = rslt.result.errors
      return res
    }
  },
  // <<<<<<<<<<<<<<<<<<<<<<<<<<<<<<<<<<<<<<<<<<<< policy tableEntry
  // >>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>> routing policy
  async getRoutingPolicyList ({commit, state}, loadingOpt) {
    commit('resetRoutingPolicyList')
    const {code, result} = await this.$axios.$get(state.apiUrlPath['routingPolicies'], loadingOpt)
    if (code !== undefined && (code).toLowerCase() === 'ok') {
      // commit for staticRouting
      commit('setRoutingPolicyList', result)
      return true
    } else {
      return false
    }
  },
  async addRoutingPolicyList ({commit, state}, addParam) {
    const {code, result} = await this.$axios.$post(state.apiUrlPath['routingPolicies'], addParam)
    if (code !== undefined && (code).toLowerCase() === 'ok') {
      commit('addRoutingPolicyList', result)
      this.dispatch(`common/common/setIsChanged`, true)
      return true
    } else {
      return false
    }
  },
  async editRoutingPolicyList ({commit, state}, putParam) {
    const url = `${state.apiUrlPath['routingPolicies']}/${state.routingPolicy.id}`
    const {code, result} = await this.$axios.$put(url, putParam)
    if (code !== undefined && (code).toLowerCase() === 'ok') {
      commit('editRoutingPolicyList', result)
      return true
    } else {
      return false
    }
  },
  async delRoutingPolicyList ({commit, state}, param) {
    // apply partialError.
    const res = {code: 'nok'}
    // multi delete
    const delParam = {items: []}
    for (const idx of param.idList) {
      delParam.items.push({id: idx.id, pokName: idx.pokName})
    }
    const apiUrl = state.apiUrlPath['routingPolicies']
    let rslt
    if (param.idList !== undefined && param.idList.length === 1) {
      // single
      rslt = await this.$axios.$delete(`${apiUrl}/${param.idList[0].id}`)
    } else {
      // multi
      rslt = await this.$axios.$delete(apiUrl, {data: delParam})
    }
    if (rslt.code !== undefined && (rslt.code).toLowerCase() === 'ok') {
      commit('delRoutingPolicyList', param.itemIndexList)
      res.code = 'ok'
      return res
    } else {
      res.code = rslt.code
      res.errors = rslt.result.errors
      return res
    }
  }
  // <<<<<<<<<<<<<<<<<<<<<<<<<<<<<<<<<<<<<<<<<<<< routing policy
}

export const getters = {
}

export const strict = false
